import { axiosAuth, axiosNoAuth } from '../../config/axiosInstances';
import { Api_url } from '../../common/api_url';
import { API_XANO_BASE_URL } from '../../config/api_config';

export function getQuiz(lessonID, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosNoAuth.get(
        API_XANO_BASE_URL +
        Api_url.GetQuizForLesson +
        `?lesson_id=${lessonID}`
      );

      successCallback && successCallback(response.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}

export function getQuizActivity(userId, lessonId, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosNoAuth.get(
        API_XANO_BASE_URL +
        Api_url.GetQuizActivity +
        `?user_id=${userId}` +
        `&lesson_id=${lessonId}`
      );

      successCallback && successCallback(response.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}
export function updateQuizActivity(userId, lessonId, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      let response = await axiosNoAuth.post(
        API_XANO_BASE_URL +
        Api_url.UpdateQuizActivity +
        `?user_id=${userId}` +
        `&lesson_id=${lessonId}`
      );

      successCallback && successCallback(response.data);
    } catch (e) {
      console.error(e);
      errorCallback && errorCallback(e.response.data.message);
    }
  };
}

export function getChallengeInfo(user_id, mskill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.GetChallengeInfo, {
        params: {
          user_id,
          mskill_slug
        }
      })

      successCallback && successCallback(response.data)

    } catch (err) {
      console.log(err)
      errorCallback && errorCallback(err?.data)
    }
  }
}

export function createNewChallenge(user_id, mskill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.CreateNewChallenge, {
        user_id,
        mskill_slug
      })

      successCallback && successCallback(response.data)

    } catch (err) {
      console.log(err)
      errorCallback && errorCallback(err?.data)
    }
  }
}

export function declineChallenge(user_id, mskill_slug, successCallback, errorCallback) {
  return async function (dispatch) {
    try {

      const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.DeclineChallenge, {
        user_id,
        mskill_slug
      })

      successCallback && successCallback(response.data)

    } catch (err) {
      console.log(err)
      errorCallback && errorCallback(err?.data)
    }
  }
}

export function getQuizStats(quiz_id, successCallback, errorCallback) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.get(
        API_XANO_BASE_URL + Api_url.GetQuizStats,
        {
          params: {
            quiz_id
          },
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err?.data);
    }
  };
}

export function addQuizOptionSelection(
  quiz_id,
  quiz_option,
  successCallback,
  errorCallback
) {
  return async function (dispatch) {
    try {
      const response = await axiosAuth.post(
        API_XANO_BASE_URL + Api_url.AddQuizOptionSelection,
        {
          quiz_id,
          quiz_option,
        }
      );

      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err?.data);
    }
  };
}

export function userTakenChallengeForSkill(skill_slug, user_id, successCallback, errorCallback) {
  return async function (dispatch) {


    try {
      const response = await axiosAuth.get(API_XANO_BASE_URL + Api_url.UserTakenChallengeForSkill, {
        params: {
          user_id,
          skill_slug
        }
      })
      // console.log({ response })
      successCallback && successCallback(response.data);
    } catch (err) {
      console.log(err);
      errorCallback && errorCallback(err?.data);
    }
  }
}

export function generateRandom(successCallback , errorCallback){
  return async function(dispatch){
    try{
      const response = await axiosNoAuth.get(API_XANO_BASE_URL + Api_url.GetRandomNumber);

      successCallback && successCallback(response.data);

    }
    catch(err){
      console.log(err);
      errorCallback && errorCallback(err);
      

    }
  }
}